import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { VideoDto } from 'src/app/models/trofaco/videoDto';
import { VideoService } from 'src/app/modules/core/services/video.service';
import { ConfirmDeleteModalComponent } from 'src/app/modules/core/components/delete-modal/confirm-delete-modal-component';
import { ArrayHelper } from 'src/app/models/helpers/array-helper';

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html'
})
export class VideosComponent implements OnInit {
    @ViewChild(ConfirmDeleteModalComponent, { static: false }) confirmDeleteModal: ConfirmDeleteModalComponent;

    @Input()
    plantingSiteAreaId: string;

    @Input()
    videos: VideoDto[] = [];

    sortedvideos: VideoDto[];

    private readonly confirmDeleteMsg = "Are you sure you want to delete";

    constructor(private videoService: VideoService) { }

    async ngOnInit() 
    { 
        for (let video of this.videos) {
            video.date = new Date(video.date);
        }
        this.sortCollectionByDate();
    }

    async addVideo(video: VideoDto) {
        const result = await this.videoService.addVideo(this.plantingSiteAreaId, video);
        video.id = result;
        this.videos.push(video);
        this.sortCollectionByDate();
    }

    async updateVideo(video: VideoDto) {
        await this.videoService.updateVideo(video);
        let index = this.videos.findIndex(x => x.id == video.id);
        this.videos[index] = video;
        this.sortCollectionByDate();
    }

    async delete(video: VideoDto) {
        let result = await this.confirmDeleteModal.showAwait(this.confirmDeleteMsg);
        if (result) {
            await this.videoService.deleteVideo(video.id);
            let index = this.videos.findIndex(x => x.id == video.id);
            this.videos.splice(index, 1);
            index = this.sortedvideos.findIndex(x => x.id == video.id);
            this.sortedvideos.splice(index, 1);
        }
    }

    sortCollectionByDate() {
        this.sortedvideos = ArrayHelper.sortBy( this.videos, false, video => video.date);
    }
}

